<template>
  <Panel
    :class="'panel-appearance-panel'"
    :variant="['30-paddings', 'default', 'rounded']"
  >
    <Subheader
      :text="$$t('Tournament Type')"
      class="tournament-info-wrapper__title mb-5"
    />
    <p class="tournament-type-class">
      {{
        $t(
          'web_tournament_type_msg',
          'Select `Free` for open access or `Paid` to require an entry fee. Specify the fee and currency if `Paid` is selected.'
        )
      }}
    </p>
    <div class="tournament-creation-paid-section">
      <div class="row mb-5 tournamet-paid-type">
        <TournamentSettingPaidType class="col-3" />
        <div class="col-4">
          <TournamentSettingCurrency />
        </div>
        <div class="col-4 countries-restriction">
          <TournamentSettingAmmount />
        </div>
      </div>
    </div>
  </Panel>
</template>

<script>
import { translate } from '@/mixins/translate';
import Panel from '@/components/atoms/Panel';

// import CollapsiblePanel from '@/components/atoms/CollapsiblePanel';
import TournamentSettingPaidType from '@/views/tournaments/management/singleTournament/components/SettingsTournamentType';
import TournamentSettingCurrency from '@/views/tournaments/management/singleTournament/components/SettingsTournamentCurrency';
import TournamentSettingAmmount from '@/views/tournaments/management/singleTournament/components/SettingsTournamentAmmount';

import Subheader from '@/components/atoms/Subheader';
export default {
  name: 'PaidSection',
  components: {
    // CollapsiblePanel,
    Panel,
    TournamentSettingCurrency,
    TournamentSettingPaidType,
    TournamentSettingAmmount,
    Subheader,
  },
  mixins: [translate('_web_tournament_settings')],
};
</script>
<style lang="scss">
.tournament-creation-paid-section {
  padding: 13px;
}
.tournament-type-class {
  font-family: Exo;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
  color: var(--ph-secondary-text);
}
.paid-title :nth-child(1) h4 > span {
  font-size: $hr-heading-5 !important;
}

.tournamet-paid-type label {
  padding-bottom: 15px;
  font-size: $hr-text-small !important;
  font-weight: 600;
}

.tournamet-paid-type input {
  background-color: $hr-bg-header;
  border: 2px solid transparent;
  width: 70% !important;
}

.tournament-country .autosuggest_clear-icon {
  margin: 10px 125px 0px 0px;

  @media only screen and (max-width: 1875px) {
    margin: 30px 125px 0px 0px;
  }

  .app-rtl & {
    margin: 30px 0px 0px 110px;
  }

  @media only screen and (max-width: 1645px) {
    .app-rtl & {
      margin: 50px 0px 0px 110px;
    }
  }

  @media only screen and (min-width: 1790px) {
    .app-rtl & {
      margin: 4px 0px 0px 120px !important;
    }
  }
}

.countries-restriction .autosuggest_clear-icon {
  margin: 10px 125px 0px 0px !important;

  .app-rtl & {
    margin: 45px 0px 0px 0px !important;
    padding-left: 70px !important;
  }

  @media only screen and (max-width: 1875px) {
    margin: 30px 125px 0px 0px !important;
  }

  @media only screen and (min-width: 1822px) {
    .app-rtl & {
      margin: 30px 0px 0px 0px !important;
      padding-left: 70px !important;
    }
  }
}

.tournamet-paid-type .segment-control-btn {
  background-color: $hr-bg-header;
}

.countries-restriction .playhera-icon {
  margin-right: 317px;

  .app-rtl & {
    margin-left: 55px !important;
  }
}

.tournament-country .align-top {
  margin-right: 285px;

  .app-rtl & {
    margin-left: 55px;
  }
}

.promo-logo-video label {
  padding-bottom: 15px;
  font-size: $hr-text-small !important;
  font-weight: 600;
}

.organizer-sponsor-logos {
  width: 50% !important;
}

.organizer-sponsor-logos label {
  padding-bottom: 15px;
  font-size: $hr-text-regular !important;
  font-weight: 600;
}

.organizer-sponsor-logos input {
  background-color: $hr-bg-header;
  border: 2px solid transparent;
  width: 12rem !important;
}

.organizer-sponsor-logos .organizer-logo {
  width: 10rem !important;
}

.logo-org {
  width: 80rem !important;
}

.default-sponsor-logo label {
  padding-bottom: 15px;
  font-size: $hr-text-regular !important;
  font-weight: 600;
  padding-top: 15px;
}

.default-sponsor-logo input {
  background-color: $hr-bg-header;
  border: 2px solid transparent;
}

.logo-sponsor .add-country {
  margin-top: 45px;
}

.logo-sponsor .add-country-row {
  margin-top: -3rem !important;
  padding-bottom: 40px;
}

.logo-sponsor .logo-item {
  padding-bottom: 10px;
}

.logo-sponsor .country-logos :nth-child(3) {
  margin-right: -30px !important;
  padding-top: 20px;
}

.logo-sponsor .autosuggest_clear-icon {
  margin: 30px -10px 0px 0px !important;
}
</style>
